;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import {
	DEFAULT_ONBOARDING_TOURS_STORAGE,
	type OnboardingToursStorageValue,
} from "@/features/onboarding-tours/types/tour-persistence";

const STORAGE_KEY_PREFIX = "onboarding-tours:v2";

interface StorageLike {
	getItem: (key: string) => string | null;
	setItem: (key: string, value: string) => void;
}

interface WindowLike {
	localStorage?: StorageLike;
}

export function getOnboardingToursStorageKey({
	organizationId,
	userId,
}: {
	organizationId: string;
	userId: string;
}): string {
	return `${STORAGE_KEY_PREFIX}:${organizationId}:${userId}`;
}

function getStorage(windowObject?: WindowLike): StorageLike | null {
	if (windowObject?.localStorage) {
		return windowObject.localStorage;
	}
	if (typeof window === "undefined" || !window.localStorage) {
		return null;
	}
	return window.localStorage;
}

export function readOnboardingToursStorage({
	organizationId,
	userId,
	windowObject,
}: {
	organizationId: string;
	userId: string;
	windowObject?: WindowLike;
}): OnboardingToursStorageValue {
	const storage = getStorage(windowObject);
	if (!storage) {
		return structuredClone(DEFAULT_ONBOARDING_TOURS_STORAGE);
	}

	try {
		const raw = storage.getItem(
			getOnboardingToursStorageKey({ organizationId, userId }),
		);
		if (!raw) {
			return structuredClone(DEFAULT_ONBOARDING_TOURS_STORAGE);
		}

		const parsed = JSON.parse(raw) as Partial<OnboardingToursStorageValue>;
		return {
			objectives: {
				...DEFAULT_ONBOARDING_TOURS_STORAGE.objectives,
				...parsed.objectives,
			},
			pipeline: {
				...DEFAULT_ONBOARDING_TOURS_STORAGE.pipeline,
				...parsed.pipeline,
			},
			tourRuns: {
				...DEFAULT_ONBOARDING_TOURS_STORAGE.tourRuns,
				...parsed.tourRuns,
			},
		};
	} catch {
		return structuredClone(DEFAULT_ONBOARDING_TOURS_STORAGE);
	}
}

export function writeOnboardingToursStorage({
	organizationId,
	userId,
	value,
	windowObject,
}: {
	organizationId: string;
	userId: string;
	value: OnboardingToursStorageValue;
	windowObject?: WindowLike;
}): void {
	const storage = getStorage(windowObject);
	if (!storage) {
		return;
	}

	try {
		storage.setItem(
			getOnboardingToursStorageKey({ organizationId, userId }),
			JSON.stringify(value),
		);
	} catch {
		// localStorage may be unavailable
	}
}
